import { EPromotionStatus } from '@/services/connecteur'

export default class SetStatusParameter {
  promotionId: number | undefined = undefined
  statusId: EPromotionStatus = EPromotionStatus.NEW
  reason = -1

  constructor(value: Partial<SetStatusParameter> | undefined = undefined) {
    if (value) {
      Object.assign(this, value)
    }
  }
}
